import { useContext, useEffect, useMemo } from "react";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import { useGetAbout } from "../../shared/hooks/useAbout";
import { LoadingContext } from "../../shared/providers/loading/loading.provider";
import { markdownToHtml } from "../../shared/helpers/utils";
import { Player } from "../../components/Player/Player";

function AboutPage() {
    const { translate, lang } = useContext(TranslationContext);
    const { setIsLoading } = useContext(LoadingContext);

    const { data, isLoading } = useGetAbout(lang ?? "");
    const page = useMemo(() => {
        if (!data?.success || !data?.data) return null;
        return data.data;
    }, [data]);

    useEffect(() => { setIsLoading(isLoading) }, [isLoading]);

    return (
        <div className="row px-md-31 px-1 pb-5">
            <div className="col-12">
                <section className="about">
                    <h1 className="text-h2-smbd my-2">
                        {translate("nav.about", "About Prosperh")}
                    </h1>
                    <div className="d-flex flex-column gap-2">

                        {page?.videoUrl && <Player videoSrc={page.videoUrl} />}

                        {page?.content && <div className="rich_text text-bd1-rg color-neutrals-black" dangerouslySetInnerHTML={{ __html: markdownToHtml(page?.content) }}>
                        </div>}
                    </div>
                </section>
            </div>
        </div>
    );
}

export default AboutPage;
